document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.menu__item--has-children .submenu-toggle');

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const menuItem = this.closest('.menu__item--has-children');
      const expanded = this.getAttribute('aria-expanded') === 'true';

      // Close all first
      closeAllMenus();

      if (!expanded) {
        // Open current
        this.setAttribute('aria-expanded', 'true');

        // Handle megamenu or dropdown
        const panel = menuItem.querySelector('.menu__megamenu, .menu__dropdown');
        if (panel) {
          panel.classList.add('show', 'animate', 'visible');
          panel.setAttribute('data-open', 'true');

          // Curtain sibling
          const curtain = menuItem.parentElement.querySelector('.menu__curtain');
          if (curtain) {
            curtain.classList.add('show');
            curtain.style.height = `${panel.offsetHeight}px`;
          }

          // Listen for focusout to close
          panel.addEventListener('focusout', handleFocusOut);
        }
      }
    });
  });

  // ESC key closes all
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeAllMenus();
    }
  });

  function handleFocusOut(e) {
    const panel = e.currentTarget;
    // Delay to allow focus to move
    setTimeout(() => {
      if (!panel.contains(document.activeElement)) {
        closeAllMenus();
      }
    }, 10);
  }

  function closeAllMenus() {
    // Close all toggles
    document.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Remove classes from menus
    document.querySelectorAll('.menu__megamenu[data-open], .menu__dropdown[data-open]').forEach(panel => {
      panel.classList.remove('show', 'animate', 'visible');
      panel.removeAttribute('data-open');
    });

    // Remove curtain
    document.querySelectorAll('.menu__curtain.show').forEach(curtain => {
      curtain.classList.remove('show');
      curtain.style.height = '';
    });
  }
  setTimeout(() => {
  document.querySelector('.header__btn-menu').addEventListener('keydown', function(event) {
  if (event.key === 'Enter') {
    event.preventDefault(); // Optional: prevent default behavior
    this.click(); // Trigger click event
  }
});
document.querySelectorAll('.footer__section-head').forEach(function(btn) {
  btn.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Optional
      btn.click();
    }
  });
});
    }, 2000);
  document.querySelector('.header__btn-menu')?.addEventListener('click', () => {
  setTimeout(() => {
    const linkToFocus = document.querySelector('.popup-navigation__menu .menu__item:nth-child(2) a');
    linkToFocus?.focus();
  }, 1000); // 1000ms = 1 second
});
const closeBtn = document.querySelector('.popup-navigation__close');
const backBtn = document.querySelector('.popup-navigation__back');
const popup = document.querySelector('.popup-navigation');
const headerLogo = document.querySelector('.header__logo a');

if (closeBtn) {
  // Make the close button focusable
  closeBtn.setAttribute('tabindex', '0');

  // Trigger click on Enter key
  closeBtn.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      closeBtn.click();
    }
  });

  // Add focus to .header__logo after click
  closeBtn.addEventListener('click', () => {
    if (headerLogo) {
      headerLogo.focus();
    }
  });
}

if (backBtn) {
  // Make the back button focusable
  backBtn.setAttribute('tabindex', '0');
  backBtn.setAttribute('aria-label', 'Back');
  backBtn.setAttribute('role', 'button');

  // Trigger click on Enter key
  backBtn.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      backBtn.click();
    }
  });
}

// Trigger close on Escape key when focus is inside popup
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const activeElement = document.activeElement;
    if (popup && closeBtn && popup.contains(activeElement)) {
      closeBtn.click();
      headerLogo.focus();
    }
  }
});

jQuery(document).on('keydown', function(e) {
  var popupNav = jQuery('.popup-navigation');
  var notifCookies = jQuery('.notification-cookies');
  var popupCart = jQuery('.popup-cart');
  var popupContact = jQuery('.popup-product-contact'); // New popup

  var activeContainer = null;

  if (popupContact.is(':visible') && popupContact.has(document.activeElement).length) {
    activeContainer = popupContact;
  } else if (popupNav.is(':visible') && popupNav.has(document.activeElement).length) {
    activeContainer = popupNav;
  } else if (notifCookies.is(':visible') && notifCookies.has(document.activeElement).length) {
    activeContainer = notifCookies;
  } else if (popupCart.is(':visible') && popupCart.has(document.activeElement).length) {
    activeContainer = popupCart;
  } else if (popupContact.is(':visible')) {
    activeContainer = popupContact;
  } else if (popupNav.is(':visible')) {
    activeContainer = popupNav;
  } else if (notifCookies.is(':visible')) {
    activeContainer = notifCookies;
  } else if (popupCart.is(':visible')) {
    activeContainer = popupCart;
  } else {
    return; // None visible, no trap
  }

  var focusableElements = activeContainer
    .find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])')
    .filter(':visible');

  var firstElement = focusableElements.first()[0];
  var lastElement = focusableElements.last()[0];

  if (e.key === 'Tab') {
    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }
});


const cookieCloseBtn = document.querySelector('.notification-cookies__button-close');

if (cookieCloseBtn) {
  // Make it focusable
  cookieCloseBtn.setAttribute('tabindex', '0');

  // Handle Enter key
  cookieCloseBtn.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      cookieCloseBtn.click();
    }
  });
}
  const popupCart = document.querySelector('.popup-cart');
  const closeCartBtn = document.querySelector('.popup-cart__close');

  if (closeBtn) {
    // Make close button focusable
    closeCartBtn.setAttribute('tabindex', '0');

    // Trigger click on Enter key
    closeCartBtn.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        closeCartBtn.click();
      }
    });
  }

  // Trigger close on Escape key when focus is inside popup-cart
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const activeElement = document.activeElement;
      if (popupCart && closeCartBtn && popupCart.contains(activeElement)) {
        closeCartBtn.click();
      }
    }
  });
  function focusFirstInPopupCart() {
  const focusableSelectors = 'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])';
  const $firstFocusable = jQuery('.popup-cart').find(focusableSelectors).filter(':visible').first();
  if ($firstFocusable.length) {
    $firstFocusable.focus();
  }
}
jQuery('.js-product-button-add-to-cart, .header__btn-cart,.footbar-product__button-add-to-cart button').on('click', function() {
  setTimeout(focusFirstInPopupCart, 2000);
});
jQuery('.shogun-accordion-title').attr('tabindex', '0').on('keydown', function(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    jQuery(this).click();
  }
});
jQuery('.product-options__section .product-options__value')
  .attr('tabindex', '0')
  .attr('role', 'button')
  .each(function () {
    const value = jQuery(this).attr('data-value');
    if (value) {
      jQuery(this).attr('aria-label', value);
    }

    jQuery(this).on('keydown', function (event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        jQuery(this).click();
      }
    });
    jQuery('.product-options__section').each(function () {
  const property = jQuery(this).attr('data-property') || '';
  jQuery(this)
    .attr('role', 'radiogroup')
    .attr('aria-label', 'Choose a Product ' + property);
});
jQuery('.product-options__section .product-options__value').attr('role', 'radio');
    



    jQuery(this).on('click', function () {
      // Remove aria-selected from all siblings
      jQuery('.product-options__section .product-options__value')
        .attr('aria-checked', 'false');

      // Add aria-selected to the clicked one
      jQuery(this).attr('aria-checked', 'true');
    });
  });


  document.querySelectorAll('.input-quantity input').forEach(input => {
  input.setAttribute('aria-live', 'assertive');
  input.setAttribute('role', 'alert');
});

document.querySelectorAll('.input-quantity .cursor-pointer').forEach(button => {
  button.setAttribute('tabindex', '0');
  const control = button.getAttribute('data-control');
  if (control) {
    button.setAttribute('aria-label', control);
  }

  // Add keydown listener for Enter key
  button.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      button.click();
    }
  });
});

document.querySelectorAll('.js-product-button-add-to-cart').forEach(button => {
  button.addEventListener('click', () => {
    // Optional: get the product name
    const productName = button.getAttribute('data-product-name') || 'Item';

    // Update the ARIA live region with the announcement
    const announcement = document.getElementById('cart-announcement');
    if (announcement) {
      announcement.textContent = `${productName} has been added to your cart.`;
    }
  });
});
  // Set up a MutationObserver to monitor class changes
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        const target = mutation.target;
        if (target.classList.contains('hydrated')) {
          setTimeout(function () {
            jQuery(document).on('click', '.lb-spc-details-btn', function () {
            setTimeout(function () {
              // Add tabindex to - and + buttons
              jQuery('.lb-spc-details-qty-picker-m, .lb-spc-details-qty-picker-p').attr('tabindex', '0');
          
              // Add tabindex and ARIA roles to quantity display
              jQuery('.lb-spc-details-qty-picker-q')
                .attr('tabindex', '0')
                .attr('role', 'alert')
                .attr('aria-live', 'assertive');
            }, 500);
          });
          
          jQuery(document).on('keydown', '.lb-spc-details-qty-picker-m, .lb-spc-details-qty-picker-p', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
              e.preventDefault();       // Stop browser from doing anything else
              e.stopImmediatePropagation(); // Stop any duplicate handlers
              jQuery(this).trigger('click'); // Trigger click manually
            }
          });



            var $closeIcon = jQuery('.lb-addon-popup-close-icon');
            var $detailsBtn = jQuery('.lb-spc-details-btn');
            var $continuebtn = jQuery('.lb-addon-popup-continue-btn');
            
            if ($closeIcon.length) {
              $closeIcon.attr('tabindex', '0').focus();
              $closeIcon.on('keydown', function(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                  jQuery(this).click();
                }
              });
            }
            
            if ($continuebtn.length) {
              $continuebtn.attr('tabindex', '0');
              $continuebtn.on('keydown', function(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                  jQuery(this).click();
                }
              });
            }
            
            if ($detailsBtn.length) {
              $detailsBtn.attr('tabindex', '0');
              $detailsBtn.on('keydown', function(event) {
                if (event.key === 'Enter' || event.keyCode === 13) {
                  jQuery(this).click();
                }
              });
            }

              var $container = jQuery('#lb-addon-popup-container-id');
  
  // Selector for all focusable elements inside the container
  var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
  
  $container.on('keydown', function(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      var $focusable = $container.find(focusableElementsString).filter(':visible');
      var firstFocusable = $focusable.first()[0];
      var lastFocusable = $focusable.last()[0];
      var focusedElement = document.activeElement;
      
      if (e.shiftKey) { // Shift + Tab
        if (focusedElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else { // Tab
        if (focusedElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  });
          }, 1000);
          observer.disconnect(); // stop observing after alert
          break;
        }
      }
    }
  });

  // Start observing all elements that might get the hydrated class
  const allElements = document.querySelectorAll('*');
  allElements.forEach((el) => {
    observer.observe(el, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  // Optionally: Watch for new elements being added to the DOM
  const domObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Only element nodes
          observer.observe(node, {
            attributes: true,
            attributeFilter: ['class'],
          });
        }
      });
    }
  });

  domObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
  jQuery(document).on('click', '.footer__section-head', function () {
    const $this = jQuery(this);
    const isExpanded = $this.attr('aria-expanded') === 'true';

    $this.attr('aria-expanded', !isExpanded);
});
  var popupButton = jQuery('.js-popup-button');
  var closeButton = jQuery('.popup-product-contact__close');
  var addToCartButton = jQuery('.product-page-info__button-add-to-cart .js-product-button-add-to-cart');

  // Set tabindex="0" on both buttons on page load
  popupButton.attr('tabindex', '0');
  closeButton.attr('tabindex', '0');
  closeButton.attr('aria-label', 'Close');
  // Allow Enter key to trigger click
  popupButton.on('keydown', function (e) {
    if (e.key === 'Enter') {
      jQuery(this).trigger('click');
    }
  });

  closeButton.on('keydown', function (e) {
    if (e.key === 'Enter') {
      jQuery(this).trigger('click');
    }
  });

  // On click of popup open button
  popupButton.on('click', function () {
    // Show your popup here if needed

    // Focus close button after 0.5s
    setTimeout(function () {
      closeButton.focus();
    }, 500);
  });

  // On click of close button
  closeButton.on('click', function () {
    // Hide your popup here if needed

    // Focus back on Add to Cart button
    addToCartButton.focus();
  });
});